import React from 'react'
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl'
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import numbers from 'cldr-numbers-full/main/es/numbers.json'
import currencies from 'cldr-numbers-full/main/es/currencies.json'
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/es/dateFields.json'
import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json'
import esMessages from './es.json'
import { LocalStorageService } from '../../../services'

load(
    likelySubtags,
    currencyData,
    weekData,
    numbers,
    currencies,
    caGregorian,
    dateFields,
    timeZoneNames
)

loadMessages(esMessages, 'es-ES')

const localStorageService = new LocalStorageService()
let preferredLanguage = localStorageService.getLocalStorageItem("preferredLanguage")

let language = "es-ES"
let locale = "es"
if(preferredLanguage && preferredLanguage === "en"){
    language = "en-EN"
    locale = "en"
}

const Traslates = (props) => {
    return(
        <LocalizationProvider language={language}>
            <IntlProvider locale={locale}>
                {props.children}
            </IntlProvider>
        </LocalizationProvider>
    )
}
export { Traslates as default }